import { useMutation } from '@tanstack/react-query';

import { apiClient, type ApiError } from '@/_shared';

import type {
  DeliverableWholesalePriceQuerySchema,
  DeliverableWholesalePriceUpdateSchema,
} from './wholesale-prices/model';

export type OverridePayload = {
  lockdown_override_pin?: string;
  override_justification_note?: string;
};

export const useCreateWholeSaleDiscountPriceMutation = () =>
  useMutation<
    DeliverableWholesalePriceQuerySchema[],
    ApiError,
    { items: DeliverableWholesalePriceUpdateSchema[] } & OverridePayload
  >({
    mutationKey: ['WHOLESALE_DISCOUNT_PRICE_CREATE'],
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/deliverable-wholesale-prices/bulk-store',
        payload,
      }),
  });

export const useUpdateWholeSaleDiscountPriceMutation = () =>
  useMutation<
    { data: DeliverableWholesalePriceQuerySchema[] },
    ApiError,
    { items: DeliverableWholesalePriceUpdateSchema[] } & OverridePayload
  >({
    mutationKey: ['WHOLESALE_DISCOUNT_PRICE_UPDATE'],
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/deliverable-wholesale-prices/bulk-update',
        payload,
      }),
  });

export const useDeleteWholeSaleDiscountPriceMutation = () =>
  useMutation<{ data: DeliverableWholesalePriceQuerySchema[] }, ApiError, { items: number[] } & OverridePayload>({
    mutationKey: ['WHOLESALE_DISCOUNT_PRICE_DELETE'],
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/deliverable-wholesale-prices/bulk-delete',
        payload,
      }),
  });
